import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6 22.5V6H22.5V22.5ZM6 42V25.5H22.5V42ZM25.5 22.5V6H42V22.5ZM25.5 42V25.5H42V42ZM9 19.5H19.5V9H9ZM28.5 19.5H39V9H28.5ZM28.5 39H39V28.5H28.5ZM9 39H19.5V28.5H9ZM28.5 19.5ZM28.5 28.5ZM19.5 28.5ZM19.5 19.5Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 48 48",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})